(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7352],{

/***/ 93150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ TeaserFlag_TeaserFlag; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/elements/TeaserFlag/TeaserFlag.module.scss
var TeaserFlag_module = __webpack_require__(33825);
var TeaserFlag_module_default = /*#__PURE__*/__webpack_require__.n(TeaserFlag_module);
;// CONCATENATED MODULE: ./src/components/elements/TeaserFlag/TeaserFlag.tsx


var TeaserFlag = function(param) {
    var text = param.text, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((TeaserFlag_module_default()).root, " ").concat(className),
        children: text
    });
};
/* harmony default export */ var TeaserFlag_TeaserFlag = (TeaserFlag);

;// CONCATENATED MODULE: ./src/components/elements/TeaserFlag/index.ts



/***/ }),

/***/ 80814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ TravelFilterForm_TravelFilterForm; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/models/travel/filter/TravelFilterForm/TravelFilterForm.module.scss
var TravelFilterForm_module = __webpack_require__(56157);
var TravelFilterForm_module_default = /*#__PURE__*/__webpack_require__.n(TravelFilterForm_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Badge.js
var Badge = __webpack_require__(27977);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Form.js + 11 modules
var Form = __webpack_require__(28431);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./src/features/travelFilter/index.ts + 1 modules
var travelFilter = __webpack_require__(32322);
// EXTERNAL MODULE: ./src/app/hooks.ts
var hooks = __webpack_require__(98324);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 17 modules
var esm = __webpack_require__(66290);
// EXTERNAL MODULE: ./src/features/travelFilter/helpers.ts
var helpers = __webpack_require__(82700);
// EXTERNAL MODULE: ./src/components/models/travel/filter/TravelFilterNav/FilterInput/FilterInput.module.scss
var FilterInput_module = __webpack_require__(30465);
var FilterInput_module_default = /*#__PURE__*/__webpack_require__.n(FilterInput_module);
;// CONCATENATED MODULE: ./src/components/models/travel/filter/TravelFilterNav/FilterInput/FilterInput.tsx



var FilterInput = function(param) {
    var name = param.name, label = param.label, Selector = param.Selector, setOpen = param.setOpen, isOpen = param.isOpen, _colSize = param.colSize, colSize = _colSize === void 0 ? 4 : _colSize;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Group */.Z.Group, {
                as: Col/* default */.Z,
                lg: colSize,
                "data-name": name,
                className: "form-group filter-input",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((FilterInput_module_default()).fakeSelect, " ").concat(isOpen && (FilterInput_module_default()).active),
                    onClick: setOpen,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (FilterInput_module_default()).label,
                        children: label
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Group */.Z.Group, {
                as: Col/* default */.Z,
                xs: "12",
                className: "mb-2 order-lg-last ".concat((FilterInput_module_default()).filterOptionsWrap, " ").concat(isOpen && (FilterInput_module_default()).active),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    children: Selector
                })
            })
        ]
    });
};
/* harmony default export */ var FilterInput_FilterInput = (FilterInput);

;// CONCATENATED MODULE: ./src/components/models/travel/filter/TravelFilterNav/FilterInput/index.tsx


// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/app/providers/AppConfigProvider.tsx
var AppConfigProvider = __webpack_require__(43953);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./src/integrations/tracking/useTracking.tsx + 4 modules
var useTracking = __webpack_require__(624);
;// CONCATENATED MODULE: ./src/components/models/travel/filter/TravelFilterForm/TravelFilterForm.tsx













var CheckboxFilterSelector = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6908).then(__webpack_require__.bind(__webpack_require__, 96908));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(96908)
            ];
        }
    },
    ssr: false
});
var MonthFilterSelector = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 506).then(__webpack_require__.bind(__webpack_require__, 20506));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(20506)
            ];
        }
    },
    ssr: false
});
var calcInputColSize = function(appConfig) {
    var inputCount = 0;
    if (appConfig.travelFilter.inputs.destinations.enabled) {
        inputCount++;
    }
    if (appConfig.travelFilter.inputs.months.enabled) {
        inputCount++;
    }
    if (appConfig.travelFilter.inputs.travelTypes.enabled) {
        inputCount++;
    }
    return inputCount ? Math.floor(12 / inputCount) : 12;
};
var TravelFilterForm = function(param) {
    var setUrlQueryString = param.setUrlQueryString, _onChangeFilterSelection = param.onChangeFilterSelection, onChangeFilterSelection = _onChangeFilterSelection === void 0 ? function() {} : _onChangeFilterSelection;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var send = (0,useTracking/* useTracking */.r)().send;
    var appConfig = (0,react.useContext)(AppConfigProvider/* AppConfigContext */.J);
    var dispatch = (0,hooks/* useAppDispatch */.T)();
    var filterState = (0,hooks/* useAppSelector */.C)(travelFilter/* selectTravelFilter */.$C);
    var updateUrl = function() {
        setUrlQueryString((0,helpers/* buildTravelFilterUrlQuery */.ye)(filterState.filterSelections, filterState.query));
    };
    /** execute **/ var applyFilter = function() {
        executeFilterQuery();
        setOpenFilter("");
        onChangeFilterSelection((0,helpers/* buildTravelFilterUrlQuery */.ye)(filterState.filterSelections, filterState.query));
    };
    var executeFilterQuery = function() {
        if (filterState.initialized) {
            updateUrl();
            dispatch((0,travelFilter/* executeTravelFilterRequest */.Iv)({}));
            send.genericEvent({
                category: "travel_filter",
                object: "filter",
                action: "execute",
                data: {}
            });
        }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var debouncedExecuteFilterQuery = (0,react.useCallback)(lodash_debounce_default()(function() {
        executeFilterQuery();
        if (filterState.query) {
            send.genericEvent({
                category: "travel_filter",
                object: "text_search",
                action: "input",
                data: {
                    filter_search_text: filterState.query
                }
            });
        }
    }, 500), [
        filterState.query
    ]);
    (0,react.useEffect)(function() {
        debouncedExecuteFilterQuery();
        // Cancel the debounced function in case it's still waiting to run when the component unmounts
        return debouncedExecuteFilterQuery.cancel;
    }, [
        debouncedExecuteFilterQuery
    ]);
    (0,react.useEffect)(function() {
        updateUrl();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filterState.updateUrlTrigger
    ]);
    /** filter query **/ var setFilterQuery = function(event) {
        dispatch((0,travelFilter/* setTravelFilterQuery */.fo)({
            query: event.target.value
        }));
    };
    /** filter inputs **/ var ref = (0,react.useState)(""), openedFilter = ref[0], setOpenFilter = ref[1];
    var toggleFilter = function(name) {
        // execute query if any filter closing
        if (openedFilter) {
            executeFilterQuery();
        }
        // handle open state
        if (openedFilter === name) {
            setOpenFilter("");
            send.genericEvent({
                category: "travel_filter",
                object: "filter_type",
                action: "close",
                data: {
                    filter_type_name: name
                }
            });
        } else {
            setOpenFilter(name);
            send.genericEvent({
                category: "travel_filter",
                object: "filter_type",
                action: "open",
                data: {
                    filter_type_name: name
                }
            });
        }
    };
    var setFilterSelection = function(param) {
        var name = param.name, selection = param.selection;
        dispatch((0,travelFilter/* setTravelFilterSelection */.rL)({
            name: name,
            selection: selection
        }));
        executeFilterQuery();
    };
    var getFilterInputLabel = function(name) {
        var badge = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        if (filterState.filterSelections) {
            var selection = filterState.filterSelections[name];
            if (selection.length > 0) {
                badge = /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                    pill: true,
                    className: (TravelFilterForm_module_default()).inputSelectedCountBadge,
                    children: selection.length
                });
            }
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                t("travelFilter.inputLabels." + name),
                badge
            ]
        });
    };
    var getFilterFromState = function(name) {
        return filterState.filters.find(function(filter) {
            return filter.name === name;
        });
    };
    var getFilterSelection = function(name) {
        return filterState.filterSelections ? filterState.filterSelections[name] : [];
    };
    var inputColSize = calcInputColSize(appConfig);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                className: (TravelFilterForm_module_default()).root,
                children: [
                    appConfig.travelFilter.inputs.destinations.enabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterInput_FilterInput, {
                        name: "destination",
                        label: getFilterInputLabel("destinations"),
                        Selector: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxFilterSelector, {
                            filter: getFilterFromState("destinations"),
                            selection: getFilterSelection("destinations"),
                            setSelection: function(selection) {
                                return setFilterSelection({
                                    name: "destinations",
                                    selection: selection
                                });
                            },
                            applySelection: applyFilter
                        }),
                        setOpen: function() {
                            return toggleFilter("destination");
                        },
                        isOpen: openedFilter === "destination",
                        colSize: inputColSize
                    }),
                    appConfig.travelFilter.inputs.months.enabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterInput_FilterInput, {
                        name: "months",
                        label: getFilterInputLabel("months"),
                        Selector: /*#__PURE__*/ (0,jsx_runtime.jsx)(MonthFilterSelector, {
                            filter: getFilterFromState("months"),
                            selection: getFilterSelection("months"),
                            setSelection: function(selection) {
                                return setFilterSelection({
                                    name: "months",
                                    selection: selection
                                });
                            },
                            applySelection: applyFilter
                        }),
                        setOpen: function() {
                            return toggleFilter("months");
                        },
                        isOpen: openedFilter === "months",
                        colSize: inputColSize
                    }),
                    appConfig.travelFilter.inputs.travelTypes.enabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterInput_FilterInput, {
                        name: "travelTypes",
                        label: getFilterInputLabel("travelTypes"),
                        Selector: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxFilterSelector, {
                            filter: getFilterFromState("travelTypes"),
                            selection: getFilterSelection("travelTypes"),
                            setSelection: function(selection) {
                                return setFilterSelection({
                                    name: "travelTypes",
                                    selection: selection
                                });
                            },
                            applySelection: applyFilter
                        }),
                        setOpen: function() {
                            return toggleFilter("travelType");
                        },
                        isOpen: openedFilter === "travelType",
                        colSize: inputColSize
                    })
                ]
            }),
            appConfig.travelFilter.inputs.query.enabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                className: (TravelFilterForm_module_default()).root,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Group */.Z.Group, {
                    as: Col/* default */.Z,
                    xs: "12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                        type: "text",
                        name: "query",
                        placeholder: t("travelFilter.inputLabels.query"),
                        className: (TravelFilterForm_module_default()).input,
                        value: filterState.query,
                        onChange: setFilterQuery
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var TravelFilterForm_TravelFilterForm = (TravelFilterForm);

;// CONCATENATED MODULE: ./src/components/models/travel/filter/TravelFilterForm/index.ts



/***/ }),

/***/ 14664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ TravelFilterInfoAndReset_TravelFilterInfoAndReset; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/models/travel/filter/TravelFilterInfoAndReset/TravelFilterInfoAndReset.module.scss
var TravelFilterInfoAndReset_module = __webpack_require__(989);
var TravelFilterInfoAndReset_module_default = /*#__PURE__*/__webpack_require__.n(TravelFilterInfoAndReset_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 17 modules
var esm = __webpack_require__(66290);
// EXTERNAL MODULE: ./src/app/hooks.ts
var hooks = __webpack_require__(98324);
// EXTERNAL MODULE: ./src/features/travelFilter/index.ts + 1 modules
var travelFilter = __webpack_require__(32322);
;// CONCATENATED MODULE: ./src/components/models/travel/filter/TravelFilterInfoAndReset/TravelFilterInfoAndReset.tsx






var TravelFilterInfoAndReset = function() {
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var dispatch = (0,hooks/* useAppDispatch */.T)();
    var filterState = (0,hooks/* useAppSelector */.C)(travelFilter/* selectTravelFilter */.$C);
    var resetFilter = function() {
        dispatch((0,travelFilter/* resetTravelFilter */.t)({}));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TravelFilterInfoAndReset_module_default()).resultInfo,
                children: t("travelFilter.resultInfo", {
                    count: filterState.counts.filteredTotal
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                type: "button",
                className: "btn-unstyled ".concat((TravelFilterInfoAndReset_module_default()).resetBtn),
                onClick: resetFilter,
                "data-tr-click": "travel_filter:filter_reset:click",
                children: [
                    "\xbb ",
                    t("travelFilter.button.reset")
                ]
            })
        ]
    });
};
/* harmony default export */ var TravelFilterInfoAndReset_TravelFilterInfoAndReset = (TravelFilterInfoAndReset);

;// CONCATENATED MODULE: ./src/components/models/travel/filter/TravelFilterInfoAndReset/index.ts



/***/ }),

/***/ 87990:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ TravelFilterResultList_TravelFilterResultList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./src/components/models/travel/filter/TravelFilterResultList/TravelResultItemTile/TravelResultItemTile.module.scss
var TravelResultItemTile_module = __webpack_require__(20794);
var TravelResultItemTile_module_default = /*#__PURE__*/__webpack_require__.n(TravelResultItemTile_module);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Card.js + 2 modules
var Card = __webpack_require__(78182);
// EXTERNAL MODULE: ./src/components/elements/media/CloudinaryImage/index.ts + 1 modules
var CloudinaryImage = __webpack_require__(6498);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
// EXTERNAL MODULE: ./src/lib/helpers/travel.ts
var helpers_travel = __webpack_require__(87086);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 17 modules
var esm = __webpack_require__(66290);
// EXTERNAL MODULE: ./src/components/elements/TeaserFlag/index.ts + 1 modules
var TeaserFlag = __webpack_require__(93150);
;// CONCATENATED MODULE: ./src/components/models/travel/filter/TravelFilterResultList/TravelResultItemTile/TravelResultItemTile.tsx









var buildLabel = function(travel, t) {
    if ((0,helpers/* isTodayOrEarlier */.is)(new Date(travel.startDate))) {
        return t("travel.nowOnTour");
    }
    if (travel.label) {
        return travel.label;
    }
    return null;
};
var TravelResultItemTile = function(param) {
    var travel = param.travel, trackingStringPrefix = param.trackingStringPrefix;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var label = buildLabel(travel, t);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/tour/".concat(travel.urlSlug),
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: (TravelResultItemTile_module_default()).wrap,
            "data-tr-click": "".concat(trackingStringPrefix, "_travel_teaser:click"),
            "data-tr-view": "".concat(trackingStringPrefix, "_travel_teaser:view"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                className: (TravelResultItemTile_module_default()).card + " an-up",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "img-ratio-16-9",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryImage/* default */.Z, {
                            image: travel.mainImage,
                            className: "card-img",
                            altDefault: travel.name,
                            aspectRatio: 1.777,
                            width: 524,
                            responsive: false,
                            placeholderClassName: "position-absolute"
                        })
                    }),
                    label && /*#__PURE__*/ (0,jsx_runtime.jsx)(TeaserFlag/* default */.Z, {
                        text: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                        className: (TravelResultItemTile_module_default()).body,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Title */.Z.Title, {
                                className: (TravelResultItemTile_module_default()).title,
                                children: travel.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Text */.Z.Text, {
                                as: "div",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (TravelResultItemTile_module_default()).date,
                                        children: (0,helpers_travel/* buildFilterTravelDatesLabel */.KP)(travel, t)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (TravelResultItemTile_module_default()).price,
                                        children: "".concat(t("booking.priceFrom"), " ").concat((0,helpers/* formatPrice */.T4)(travel.minPrice, travel.currency))
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var TravelResultItemTile_TravelResultItemTile = (TravelResultItemTile);

;// CONCATENATED MODULE: ./src/components/models/travel/filter/TravelFilterResultList/TravelResultItemTile/index.tsx


// EXTERNAL MODULE: ./src/app/hooks.ts
var hooks = __webpack_require__(98324);
// EXTERNAL MODULE: ./src/features/travelFilter/index.ts + 1 modules
var travelFilter = __webpack_require__(32322);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/models/travel/filter/TravelFilterResultList/TravelFilterResultList.tsx






var TravelFilterResultList = function(param) {
    var initialTravels = param.travels, _immutable = param.immutable, immutable = _immutable === void 0 ? false : _immutable, _className = param.className, className = _className === void 0 ? "" : _className, trackingStringPrefix = param.trackingStringPrefix;
    var filterState = (0,hooks/* useAppSelector */.C)(travelFilter/* selectTravelFilter */.$C);
    var ref = (0,react.useState)(initialTravels ? initialTravels : filterState.travels), travels = ref[0], setTravels = ref[1];
    (0,react.useEffect)(function() {
        if (!immutable) {
            setTravels(filterState.travels);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filterState.travels
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
            children: travels.map(function(travel, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                    md: 6,
                    lg: 4,
                    xxl: 3,
                    className: "mb-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelResultItemTile_TravelResultItemTile, {
                        travel: travel,
                        trackingStringPrefix: trackingStringPrefix
                    })
                }, index);
            })
        })
    });
};
/* harmony default export */ var TravelFilterResultList_TravelFilterResultList = (TravelFilterResultList);

;// CONCATENATED MODULE: ./src/components/models/travel/filter/TravelFilterResultList/index.tsx



/***/ }),

/***/ 32322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "JS": function() { return /* reexport */ actions/* applyTravelFilterUrlQuery */.JS; },
  "Iv": function() { return /* reexport */ actions/* executeTravelFilterRequest */.Iv; },
  "zK": function() { return /* reexport */ actions/* initializeTravelFilter */.zK; },
  "t": function() { return /* reexport */ actions/* resetTravelFilter */.t; },
  "$C": function() { return /* reexport */ selectTravelFilter; },
  "Qw": function() { return /* reexport */ actions/* setInitialTravelFilterResponse */.Qw; },
  "fo": function() { return /* reexport */ actions/* setTravelFilterQuery */.fo; },
  "rL": function() { return /* reexport */ actions/* setTravelFilterSelection */.rL; }
});

// UNUSED EXPORTS: travelFilterReducer, travelFilterSelector

// EXTERNAL MODULE: ./src/features/travelFilter/actions.ts
var actions = __webpack_require__(40135);
// EXTERNAL MODULE: ./src/features/travelFilter/reducer.ts
var reducer = __webpack_require__(16052);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
;// CONCATENATED MODULE: ./src/features/travelFilter/selectors.ts

var selectTravelFilter = function(state) {
    return state.travelFilter;
};
var travelFilterSelector = (0,es/* createSelector */.P1)(selectTravelFilter, function(state) {
    return state;
});

;// CONCATENATED MODULE: ./src/features/travelFilter/index.ts





/***/ }),

/***/ 33825:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"TeaserFlag_root__wOidx"};

/***/ }),

/***/ 56157:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"TravelFilterForm_root__QRzQE","inputSelectedCountBadge":"TravelFilterForm_inputSelectedCountBadge__SZch_","input":"TravelFilterForm_input__EneeE"};

/***/ }),

/***/ 989:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"resetBtn":"TravelFilterInfoAndReset_resetBtn__cWS_B"};

/***/ }),

/***/ 30465:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fakeSelect":"FilterInput_fakeSelect__D29si","active":"FilterInput_active__Eui_K","filterOptionsWrap":"FilterInput_filterOptionsWrap__GxkTA"};

/***/ }),

/***/ 20794:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrap":"TravelResultItemTile_wrap__26jem","card":"TravelResultItemTile_card__WG1Rb","body":"TravelResultItemTile_body__SDr77","title":"TravelResultItemTile_title__yRv6X","date":"TravelResultItemTile_date__V0ysb","price":"TravelResultItemTile_price__1NIZT"};

/***/ })

}]);